export default "__VITE_ASSET__CXPxUPpF__"